import React, { ReactNode, cloneElement, useState } from "react";
import { animated, useTransition } from "@react-spring/web";
import { BaseProps } from "../common/BaseProps";
import { getProperty } from "../common/Utils";

export interface MotionGroupProps extends BaseProps {
  in?: boolean;
  enterStyles?: any;
  leaveStyles?: object;
  activeStyles?: object;
  children?: ReactNode;
  styles?: () => void;
  onEnter?: (style: any) => void;
  onLeave?: (style: any) => void;
}

export default function MotionGroup(props: MotionGroupProps) {
  const { enterStyles = {}, activeStyles = {}, leaveStyles = {} } = props;
  const [activeIndex, setActiveIndex] = useState(0);

  const onRest = () => {
    const inProps = props.in;
    if (inProps) {
      if (props.onEnter) {
        props.onEnter(inProps);
      }
    } else {
      if (props.onLeave) {
        props.onLeave(inProps);
      }
    }
  };

  const transitions = useTransition(activeIndex, {
    from: getProperty(enterStyles),
    enter: getProperty(activeStyles),
    leave: getProperty(leaveStyles),
    exitBeforeEnter: true,
    onRest
  });

  const renderElement = () => {
    return cloneElement(
      <div className="bm-MotionGroup">{props.children}</div>,
      {}
    );
  };
  return transitions((style) => (
    <animated.div style={style}>{renderElement()}</animated.div>
  ));
}
